//All Endpoints.

export const RegisterApi = `/api/authentication/signup`;
export const LoginApi = `/api/authentication/signin`;
export const SendOneTimePasswordApi = '/api/authentication/send-one-time-password';
export const GetUser = `/api/auth/getuser`;
export const VerifyOtp = `/api/authentication/verify-one-time-password`;
export const ResendOtp = `/api/auth/resendOtp`;
export const SendOtp = `/api/auth/sendOtp`;
export const ForgetPassword = `/api/auth/forgetPassword`;
export const ResetPassword = `/api/auth/resetPassword`;
export const CreateSimulation = `/api/simulation/create-simulation`;
export const EditSimulation = `/api/simulation/edit-simulation`;
export const LatSimulation = `/api/simulation/last-simulation`;
export const GetSimulationByUser = `/api/simulation/get-simulationByUser`;
export const CreatePersonalization = `/api/setting/create-personalization`;
export const EditEmail = `/api/auth/edit-email`;
export const GetPersonalization = `/api/setting/get-personalization`;
export const EditSettingPassword = `/api/setting/edit-setting-password`;
export const GetSimulation = `/api/simulation/get-simulation`;
export const GetSimulationById = `/api/simulation/get-simulation-id`;
export const GetSimulationByIdInDashboard = `/api/simulation/get-simulation-id-dashboard`;
export const DeleteSimulationById = `/api/simulation/delete-simulation-by-id`;
export const EditProfile = `/api/auth/edit-profile`;
export const EditUserImage = `/api/auth/edit-user-profile`;
export const CreateFeedbacks = `/api/feedbacks/create-feedbacks`;
export const CreateCoachTivyFeedbacks = `/api/tivy/generate-feedback`;
export const CreateDonorSimulationFeedbacks = `/api/donor-simulation-feedback/generate-feedback`;
export const GetCoachTivyFeedbacks = `/api/tivy/feedback/simulation_id`;
export const GetDonorSimulationFeedbacks = `/api/donor-simulation-feedback/simulation_id`;
export const SaveTranscription = `/api/transcription`;
export const GetFeedbacks = `/api/feedbacks/get-feedbacks`;
export const QuickPractice = `/api/quick/create-quick-simulation`;
export const GetPractice = `/api/quick/get-quick-simulation`;
export const GetCoachTivy = `/api/quick/get-quick-simulation`; // Should replace this with new endpoint
export const SaveGreeting = `/api/auth/user-greeting`;
export const CreateSubscription = `/api/subscription/create-subscription`;
export const GetSubscription = `/api/subscription/get-subscription`;
export const CancelSubscription = `/api/subscription/cancel-subscription`;
export const UpdateSubscription = `/api/subscription/update-subscription`;
export const FreeSubscription = `/api/subscription/free-subscription`;
export const UserCardsDeatils = `/api/subscription/get-CardDetails`;
export const AddCards = `/api/subscription/add-Card`;
export const UpdateCard = `/api/subscription/update-DefaultCard`;
export const DeleteCard = `/api/subscription/delete-Card`;
export const AddOns = `/api/subscription/add-on`;
export const PlusMinutes = `/api/subscription/add-minutes`;
export const AdminresetPassword = `/api/admin/verify/user-password`;

export const InSumlationFeedback = `${import.meta.env.VITE_PYTHON_API}/insimulation-feedback`;
export const GenerateFeedback = `${import.meta.env.VITE_PYTHON_API}/generate-feedback/`;
export const WebScraping = `${import.meta.env.VITE_PYTHON_API}/scrape`;
export const createGreetingBackPyth = `${import.meta.env.VITE_PYTHON_API}/dynamic-greeting`;
export const SimulationRating = `/api/simulation/simulation_id/rating`;
export const GetTranscription = `/api/transcription/simulation_id`;
export const GetPracticeScenarios = '/api/simulation-scenarios';
export const GetMostPracticedScenarios = '/api/donor-scenario-practice/most-practiced-scenarios';
export const PinScenario = '/api/simulation-scenarios/:scenario_id/pin';
export const UnpinScenario = '/api/simulation-scenarios/:scenario_id/unpin';
export const GetUserBalance = '/api/user/balance';

// Team Tier
export const JoinByLink = '/api/team/join-team';
export const CreateTeam = '/api/team/create-team';
export const GetTeam = '/api/team/get-team';
export const AddMember = '/api/team/addMember-team';
export const updateLicence = '/api/team/updateMember-licence';
export const removeMember = '/api/team/removeMember-team';
export const changeTimeMembersTeam = '/api/team/update-member-time';
export const simulationsCount = '/api/team/simulation-count';
export const leaveTeam = '/api/team/leave-team';

export const allocateTime = '/api/team/allocate-time';
export const uploadCsv = '/api/team/add-members-csv';

export const getTeamMemberSimulations = '/api/team/get-user-team-simulation';
